import React from 'react';
import './earning.css';

const AddTaxInfoCard = ({
  isUsUser = false,
  w8FormFilled = false,
  w8FormExpired = false,
  w8StatusLoading = false
}) => {
  const getNonUsMessage = () => {
    if (w8StatusLoading) {
      return 'Checking your tax form status...';
    }
    if (w8FormExpired) {
      return 'Your W-8BEN form has expired. Please update it to withdraw your earnings. Scroll to the bottom of this page and click \'Add Tax Information.\'';
    }
    if (!w8FormFilled) {
      return 'You will need to fill out the W-8BEN form before you can withdraw your earnings. To do so, scroll to the bottom of this page and click \'Add Tax Information.\'';
    }
    return 'You will need to fill out the W-8BEN form before you can withdraw your earnings. To do so, scroll to the bottom of this page and click \'Add Tax Information.\'';
  };

  return (
    <div className="d-flex gap-3 mb-4 notice_card">
      <div>
        <i className="fa-solid fa-file-invoice-dollar"></i>
      </div>
      <div className="w-full">
        <h4>Add Tax Information</h4>
        {isUsUser ? (
          <p className="add-tax-info-card__description">
            You will need to fill out the W-9 form before you can continue to withdraw your earnings.
            To do so, scroll to the bottom of this page and click
            'Add Tax Information.'
          </p>
        ) : (
          <p className="add-tax-info-card__description">
            {getNonUsMessage()}
          </p>
        )}
      </div>
    </div>
  );
};

export default AddTaxInfoCard;
